import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivationStart, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie';
import { Subscription, filter } from 'rxjs';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { StateService } from '../../state.service';
import { MenuItemDto } from './menu-item-dto';
import { SideNavService } from './sidenav.service';


@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent implements OnInit {

  largeScreen: boolean = false;

  @ViewChild('sidenav', { static: true }) public sidenav: MatSidenav | undefined;

  menuItems : Map<string, MenuItemDto[]> = new Map<string, MenuItemDto[]>();
  openSubMenus: string[] = [];

  dashboardHeader: string = '';
  loginHeader: string = '';

  sideNavToggleSubscription: Subscription;
  currentScreenSideSubscription: Subscription;
  authenticatedSubscription: Subscription;

  contentStyle = 'width:calc(100vw);';

  menuItem: MenuItemDto;

  @Input() public userName: string;

  @ViewChild(RouterOutlet) outlet: RouterOutlet;

  constructor(public translate: TranslateService,
    private stateService: StateService,
    private sideNavService: SideNavService,
    private cookieService: CookieService,
    private router: Router
    ) { }

  calculateContentStyle()
  {
    setTimeout(() => {
      let width = 180;
      if (this.sidenav && this.sidenav._content && this.sidenav._content.nativeElement)
        width =  this.sidenav._content.nativeElement.offsetWidth + 5;
      this.contentStyle = this.sidenav.opened ? 'width: calc(100vw - ' + width + 'px);' : 'width:calc(100vw);';
    });
  }

  ngOnDestroy()
  {
    if (this.sideNavToggleSubscription) this.sideNavToggleSubscription.unsubscribe();
    if (this.currentScreenSideSubscription) this.currentScreenSideSubscription.unsubscribe();
    if (this.authenticatedSubscription) this.authenticatedSubscription.unsubscribe();
  }

  ngOnInit(): void {

    this.router.events.subscribe(e => {
      if (e instanceof ActivationStart && e.snapshot.outlet === "primary")
        this.outlet.deactivate();
    });

    this.translate
    .get(['header.dashboard','header.login'
  ])
    .subscribe((translations) => {
      this.dashboardHeader = translations['header.dashboard'];
      this.loginHeader = translations['header.login'];
    });

    this.currentScreenSideSubscription = this.stateService.currentScreenSize$.subscribe((screenSize) => {
      this.largeScreen = screenSize;
    });

    this.sideNavToggleSubscription = this.sideNavService.sideNavToggleSubject.subscribe(()=> {
      if (this.sidenav) this.sidenav.toggle();
      this.calculateContentStyle();
    });

    //default menuitem
    this.authenticatedSubscription = this.stateService.isAuthenticated$.pipe(filter(val => val != null)).subscribe((isAuthenticated) => {
      this.menuItems.clear();
      this.openSubMenus = [];
      if (isAuthenticated)
      {
        this.addMenuItems();
      }
      else
      {
        this.onSideNavClose(null);
      }
    });
  }

  onSideNavClose(itemMenu: MenuItemDto)
  {
    if (!itemMenu || !itemMenu.subMenu)
    {
      let cookies = this.cookieService.getAll();
      for (let key in cookies)
      {
        if (key.includes('filter') || key.includes('page_size') || key.includes('page_index')
        || key.includes('sort'))
        {
          this.cookieService.remove(key);
        }
      }

      if (this.sidenav) this.sidenav.close();
    }
  }

  onItemClicked(itemMenu: MenuItemDto)
  {
    if (itemMenu.subMenu)
    {
      if (itemMenu.id && this.openSubMenus.includes(itemMenu.id))
        this.openSubMenus.splice(this.openSubMenus.indexOf(itemMenu.id));
      else
        this.openSubMenus.push(itemMenu.id);
    }
    this.calculateContentStyle();
  }

  addMenuItems()
  {
    let partners: MenuItemDto = {
      id: "",
      mainMenuItem: true,
      menuIcon: RouterLinkEnum.PARTNERS.menu,
      menuRouterLink:RouterLinkEnum.PARTNERS.link,
      menuSubTitle: RouterLinkEnum.PARTNERS.text,
      menuTitle: RouterLinkEnum.PARTNERS.text,
      profiles:RouterLinkEnum.PARTNERS.profiles,
      sort:"",
      subMenu: false,
      subMenuId:'settings'
    }
    let sections: MenuItemDto = {
      id: "",
      mainMenuItem: true,
      menuIcon: RouterLinkEnum.TUNNEL_SECTIONS_DASHBOARD.menu,
      menuRouterLink:RouterLinkEnum.TUNNEL_SECTIONS_DASHBOARD.link,
      menuSubTitle: RouterLinkEnum.TUNNEL_SECTIONS_DASHBOARD.text,
      menuTitle: RouterLinkEnum.TUNNEL_SECTIONS_DASHBOARD.text,
      profiles:RouterLinkEnum.TUNNEL_SECTIONS_DASHBOARD.profiles,
      sort:"",
      subMenu: false
    }
    let fehmarn: MenuItemDto = {
      id: "",
      mainMenuItem: true,
      menuIcon: RouterLinkEnum.FEHMARN.menu,
      menuRouterLink:RouterLinkEnum.FEHMARN.link,
      menuSubTitle: RouterLinkEnum.FEHMARN.text,
      menuTitle: RouterLinkEnum.FEHMARN.text,
      profiles:RouterLinkEnum.FEHMARN.profiles,
      sort:"",
      subMenu: false
    }

    let users: MenuItemDto = {
      id: "",
      mainMenuItem: true,
      menuIcon: RouterLinkEnum.USERS_LIST.menu,
      menuRouterLink:RouterLinkEnum.USERS_LIST.link,
      menuSubTitle: RouterLinkEnum.USERS_LIST.text,
      menuTitle: RouterLinkEnum.USERS_LIST.text,
      profiles: RouterLinkEnum.USERS_LIST.profiles,
      sort:"",
      subMenu: false,
      subMenuId:'settings'
    }

    let rasters: MenuItemDto = {
      id: "",
      mainMenuItem: true,
      menuIcon: RouterLinkEnum.RASTERS_LIST.menu,
      menuRouterLink:RouterLinkEnum.RASTERS_LIST.link,
      menuSubTitle: RouterLinkEnum.RASTERS_LIST.text,
      menuTitle: RouterLinkEnum.RASTERS_LIST.text,
      profiles: RouterLinkEnum.RASTERS_LIST.profiles,
      sort:"",
      subMenu: false
    }

    let rastersUpload: MenuItemDto = {
      id: "",
      mainMenuItem: true,
      menuIcon: RouterLinkEnum.RASTERS_UPLOAD_LIST.menu,
      menuRouterLink:RouterLinkEnum.RASTERS_UPLOAD_LIST.link,
      menuSubTitle: RouterLinkEnum.RASTERS_UPLOAD_LIST.text,
      menuTitle: RouterLinkEnum.RASTERS_UPLOAD_LIST.text,
      profiles: RouterLinkEnum.RASTERS_UPLOAD_LIST.profiles,
      sort:"",
      subMenu: false
    }


    let chainage: MenuItemDto = {
      id: "",
      mainMenuItem: true,
      menuIcon: RouterLinkEnum.LOAD_CHAINAGES_LIST.menu,
      menuRouterLink:RouterLinkEnum.LOAD_CHAINAGES_LIST.link,
      menuSubTitle: RouterLinkEnum.LOAD_CHAINAGES_LIST.text,
      menuTitle: RouterLinkEnum.LOAD_CHAINAGES_LIST.text,
      profiles: RouterLinkEnum.LOAD_CHAINAGES_LIST.profiles,
      sort:"",
      subMenu: false,
      subMenuId:'settings'
    }

    let sdtPosition: MenuItemDto = {
      id: "",
      mainMenuItem: true,
      menuIcon: RouterLinkEnum.SDT_POSITIONS_LIST.menu,
      menuRouterLink:RouterLinkEnum.SDT_POSITIONS_LIST.link,
      menuSubTitle: RouterLinkEnum.SDT_POSITIONS_LIST.text,
      menuTitle: RouterLinkEnum.SDT_POSITIONS_LIST.text,
      profiles: RouterLinkEnum.SDT_POSITIONS_LIST.profiles,
      sort:"",
      subMenu: false,
      subMenuId:'settings'
    }

    let sysParams: MenuItemDto = {
      id: "",
      mainMenuItem: true,
      menuIcon: RouterLinkEnum.SYSTEMPARAMS_LIST.menu,
      menuRouterLink:RouterLinkEnum.SYSTEMPARAMS_LIST.link,
      menuSubTitle: RouterLinkEnum.SYSTEMPARAMS_LIST.text,
      menuTitle: RouterLinkEnum.SYSTEMPARAMS_LIST.text,
      profiles: RouterLinkEnum.SYSTEMPARAMS_LIST.profiles,
      sort:"",
      subMenu: false,
      subMenuId:'settings'
    }

    let rasterCategories: MenuItemDto = {
      id: "",
      mainMenuItem: true,
      menuIcon: RouterLinkEnum.RASTER_CATEGORIES_LIST.menu,
      menuRouterLink:RouterLinkEnum.RASTER_CATEGORIES_LIST.link,
      menuSubTitle: RouterLinkEnum.RASTER_CATEGORIES_LIST.text,
      menuTitle: RouterLinkEnum.RASTER_CATEGORIES_LIST.text,
      profiles: RouterLinkEnum.RASTER_CATEGORIES_LIST.profiles,
      sort:"",
      subMenu: false,
      subMenuId:'settings'
    }

    let logMessages: MenuItemDto = {
      id: "",
      mainMenuItem: true,
      menuIcon: RouterLinkEnum.LOG_MESSAGES_LIST.menu,
      menuRouterLink:RouterLinkEnum.LOG_MESSAGES_LIST.link,
      menuSubTitle: RouterLinkEnum.LOG_MESSAGES_LIST.text,
      menuTitle: RouterLinkEnum.LOG_MESSAGES_LIST.text,
      profiles: RouterLinkEnum.LOG_MESSAGES_LIST.profiles,
      sort:"",
      subMenu: false
    }


    let settingsMenu: MenuItemDto = {
      id: "settings",
      mainMenuItem: true,
      menuIcon: 'unfold_more',
      menuRouterLink: null,
      menuSubTitle: '',
      menuTitle: 'Settings',
      profiles: 'ADMIN,UPLOADER,ENGINEER,VIEWER',
      sort:"",
      subMenu: true,
      subMenuOpen: false
    }

    this.addItemToMap(sections);

    this.addItemToMap(rasters);
    this.addItemToMap(rastersUpload);
    this.addItemToMap(logMessages);
    this.addItemToMap(settingsMenu);
    this.menuItems.get('').push(null);
    this.addItemToMap(rasterCategories);
    this.addItemToMap(sysParams);
    this.addItemToMap(chainage);
    this.addItemToMap(sdtPosition);
    this.addItemToMap(users);
    //this.menuItems.push(fehmarn);
    this.addItemToMap(partners);

    if (this.stateService.getProfile())
    {
      this.menuItems.forEach((value: MenuItemDto[], key: string) =>
      {
        value = value.filter(t => {
          if (t !== null)
          {
            return t.profiles.includes(this.stateService.getProfile().toString().toUpperCase()) && t.mainMenuItem;
          }
          else return true;
        });
        this.menuItems.set(key, value);
      })
    }
    this.sideNavService.setMenuItems(this.menuItems);


  }

  addItemToMap(item: MenuItemDto)
  {
    if (item && item.subMenu && item.subMenuOpen) this.openSubMenus.push(item.id);
    let key = item && item.subMenuId ? item.subMenuId : '';
    if (this.menuItems.has(key))
    {
      this.menuItems.get(key).push(item);
    }
    else
    {
      this.menuItems.set(key, [item]);
    }
  }

  public isLoading()
  {
    return this.sideNavService.isLoading();
  }
}
